"use strict";

module.exports = {
  type: 'object',
  additionalProperties: false,
  properties: {
    aerial: {
      type: 'number',
      minimum: 0,
      maximum: 1
    },
    ground: {
      type: 'number',
      minimum: 0,
      maximum: 1
    }
  }
};